import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=3820dcd8&scoped=true"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820dcd8",
  null
  
)

export default component.exports